import React from 'react';
import '../../../core/enums/GameSpecificTypes.js';
import '../../../core/enums/MaxPayoutDataTypes.js';
import '../../../core/enums/Chat.js';
import '../../../core/enums/GameModes.js';
import '../../../core/enums/IconTypes.js';
import '../../../core/enums/BetStatus.js';
import '../../../core/enums/PopupTypes.js';
import '../../../core/enums/ApiVersion.js';
import '../../../core/enums/RoundStatus.js';
import { FreeBetsStatus } from '../../../core/enums/FreeBetsStatus.js';
import '../../../core/enums/SocketEvents.js';
import { TranslationKeys } from '../../../core/enums/TranslationKeys.js';
import '../../../core/enums/TimeoutMaxValue.js';
import '../../../core/enums/ApiServiceTypes.js';
import '../../../core/enums/EnvironmentTypes.js';
import '../../../core/enums/DefaultQueryValues.js';
import '../../../core/enums/FreeBetWinningType.js';
import '../../../core/enums/DefaultQueryParams.js';
import '../../../core/enums/BetHistoryFilterTypes.js';
import '../../../core/enums/GameThemeTypes.js';
import '../../../core/enums/RequestStatus.js';
import '../../../core/enums/FetchDefaultPaths.js';
import '../../../core/enums/ResponseCodes.js';
import '../../../../_tslib-7a01aab4.js';
import '../../../../validateBalanceOnBet-af4f4a9b.js';
import '../../../core/store/chatStore.js';
import '../../../core/store/wageringStore.js';
import '../../../core/store/roundInfoStore.js';
import '../../../core/store/userCountStore.js';
import '../../../core/store/gameResultStore.js';
import '../../../core/store/resultHashStore.js';
import '../../../core/store/userWinBetsStore.js';
import '../../../core/store/notificationStore.js';
import '../../../core/store/selectedResultInfoStore.js';
import '../../../core/store/forCrashGame/inputValidationStore.js';
import '../../../core/store/forCrashGame/totalBetStore.js';
import '../../../core/store/forCrashGame/resultReportStore.js';
import '../../../core/store/forCrashGame/gameStore.js';
import '../../../core/services/liveConnection/types.js';
import 'axios';
import '../../../core/services/sound/types.js';
import '../../../core/services/sound/SoundService.js';
import '../../../core/services/sound/defaultSounds.js';
import '../../../core/services/api/types.js';
import '../../../core/services/ApiServices.js';
import '../../../../momentFormat-e9197995.js';
import '../../../core/polyfill.js';
import 'mobx';
import '../../../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../../core/enums/BogLineGameConfig.js';
import '../../../core/helpers/parseQuery.js';
import '../../../core/enums/StatisticsSortingTypes.js';
import '../../../core/services/api/BaseApiService.js';
import '../../../core/helpers/deepCopy.js';
import '../../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../../table-line/t_types/enums/PopupTypes.js';
import '../../../core/helpers/formatDate.js';
import '../../../core/helpers/isMobile.js';
import '../../../core/enums/bogGameNames.js';
import '../../../core/helpers/updateHalfBets.js';
import 'howler';
import '../../../../_commonjsHelpers-17aad09c.js';

var FreeBetsList = function (_a) {
    var t = _a.t, freeBetsList = _a.freeBetsList, selectFreeBet = _a.selectFreeBet, handleInfoData = _a.handleInfoData, selectedFreeBetId = _a.selectedFreeBetId, isBogLine = _a.isBogLine;
    return (React.createElement("div", { className: 'free-bets-wr-bottom' },
        React.createElement("div", { className: 'free-bets-wr-bottom-head' },
            React.createElement("div", { className: 'free-bets-wr-bottom-head-row' }, t(TranslationKeys.Count)),
            React.createElement("div", { className: 'free-bets-wr-bottom-head-row' }, t(TranslationKeys.Bet1)),
            isBogLine && (React.createElement("div", { className: 'free-bets-wr-bottom-head-row sub' },
                t(TranslationKeys.OddFreeBet),
                React.createElement("span", { className: 'free-bets-wr-bottom-head-row-txt' }, t(TranslationKeys.Min)))),
            React.createElement("div", { className: 'free-bets-wr-bottom-head-date' }, t(TranslationKeys.EndDate))),
        React.createElement("div", { className: 'free-bets-wr-bottom-content' },
            React.createElement("div", { className: 'scrollable-container' }, freeBetsList.map(function (freeBet) { return (React.createElement("div", { className: "free-bets-wr-bottom-content-wrap ".concat(selectedFreeBetId === freeBet.id ? 'active' : ''), key: freeBet.id },
                React.createElement("div", { className: 'free-bets-wr-bottom-content-wr-row' }, freeBet.count),
                React.createElement("div", { className: 'free-bets-wr-bottom-content-wr-row' }, freeBet.amount),
                isBogLine && React.createElement("div", { className: 'free-bets-wr-bottom-content-wr-row' },
                    "x",
                    freeBet.minOdd),
                React.createElement("div", { className: 'free-bets-wr-bottom-content-wr-date' },
                    freeBet.expireDateFreeBet,
                    React.createElement("span", { className: 'free-bets-wr-bottom-content-wr-txt' }, freeBet.expiredTime)),
                React.createElement("div", { className: 'free-bets-wr-bottom-content-wr-info' },
                    React.createElement("div", { className: 'free-bets-wr-bottom-content-wr-info-icon', onClick: function (evt) { return handleInfoData(evt, freeBet); } },
                        React.createElement("i", { className: 'ui-lib-question' })),
                    React.createElement("div", { className: "free-bets-wr-bottom-content-wr-info-switch ".concat(freeBet.remainingCount === 0 || freeBet.status === FreeBetsStatus.Expired ? 'disabled' : '') },
                        React.createElement("label", { className: 'switch' },
                            React.createElement("input", { type: 'checkbox', checked: freeBet.id === selectedFreeBetId, onChange: function () { return selectFreeBet(freeBet); } }),
                            React.createElement("span", { className: 'slider round' })))))); })))));
};

export { FreeBetsList };
